var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-members-connected",on:{"click":function($event){return _vm.seeMore();}}},[_vm._l((_vm.membersConnectedFiltered),function(member){return _c('span',{key:("" + _vm.prefix + (member.username)),style:({
      'border': ("1px solid " + (member.color))
    }),attrs:{"title":member.username}},[_c('i',{style:({
      'background-color': ("" + (member.color))
    })})])}),(_vm.membersConnected.length > _vm.maxMembers)?_c('div',[_vm._v(" ... ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }